import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo_1.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-11f520d3")

_pushScopeId("data-v-11f520d3")
const _hoisted_1 = { class: "min-h-screen flex flex-col justify-center items-center" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "absolute top-0 left-0 w-full h-full bg-gray-100 sm:bg-primary sm:bg-opacity-75 z-20" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "bg-image" }, null, -1)
const _hoisted_4 = { class: "relative z-30 w-full sm:w-100 mt-6 px-4 sm:px-0 pt-4 sm:bg-white sm:rounded-lg sm:shadow-md overflow-hidden text-left" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row justify-center mb-4" }, [
  /*#__PURE__*/_createVNode("div", { class: "overflow-hidden h-16 w-16" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_0,
      alt: "Dime Budget",
      style: {"max-width":"12rem"},
      class: "crisp h-full w-64"
    })
  ])
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _hoisted_5,
      _createVNode(_component_router_view)
    ])
  ]))
})